function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  fill: "currentColor",
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59.659,46.733l-1.958,1.13c0.188,0.682,0.298,1.396,0.298,2.137 c0,0.742-0.109,1.456-0.298,2.138l1.958,1.13c0.956,0.553,1.284,1.775,0.731,2.732c-0.552,0.956-1.774,1.284-2.731,0.731 l-1.954-1.128c-1.003,1.02-2.277,1.766-3.705,2.134v2.262c0,1.104-0.896,2-2,2s-2-0.896-2-2v-2.262 c-1.428-0.368-2.703-1.114-3.705-2.134l-1.954,1.128c-0.957,0.553-2.18,0.225-2.731-0.731c-0.553-0.957-0.225-2.18,0.731-2.732 l1.958-1.13c-0.189-0.682-0.298-1.396-0.298-2.138c0-0.741,0.108-1.455,0.298-2.137l-1.958-1.13 c-0.956-0.553-1.284-1.775-0.731-2.732c0.552-0.956,1.774-1.284,2.731-0.731l1.954,1.128c1.002-1.02,2.277-1.766,3.705-2.134v-2.262 c0-1.104,0.896-2,2-2s2,0.896,2,2v2.262c1.428,0.368,2.702,1.114,3.705,2.134l1.954-1.128c0.957-0.553,2.18-0.225,2.731,0.731 C60.943,44.958,60.615,46.181,59.659,46.733z M50,46.001c-2.209,0-4,1.791-4,3.999c0,2.209,1.791,4,4,4s3.999-1.791,3.999-4 C53.999,47.792,52.209,46.001,50,46.001z"
});

function SvgSnowflake(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "-icon",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "25 25 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnowflake);
export default __webpack_public_path__ + "static/media/Snowflake.c8b2544d.svg";
export { ForwardRef as ReactComponent };